import { Layout } from "antd";
import styled from "styled-components";

import { theme } from "styles/theme";

export const AppContainer = styled(Layout)`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  position: relative;
  background-color: ${theme.primary.background};
`;

export const MainViewContainer = styled(Layout)`
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow: auto;
`;

export const SVGDownBackGround = styled.svg`
  position: absolute;
  margin: 0;
  padding: 0;
  bottom: 0px;
  right: 0px;
`;
